<script lang="ts">
	import QuizRow from './QuizRow.svelte';
    import type {QuizLinkInfo} from './props';

	export let quizzes: QuizLinkInfo[];
</script>

<div class="page">
	<h1>SuperQuiz</h1>

	{#each quizzes as quiz, index}
		<QuizRow url="/quiz/{quiz.id}" date={quiz.date} {index} />
	{/each}
</div>

<style>
	.page {
		padding: 16px;
	}

	h1 {
		padding-bottom: 12px;
	}
</style>
